// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-c8fe1ea6]{width:100%;display:flex;margin-top:40px;margin-bottom:20px;text-align:center;align-items:center;justify-content:flex-start;margin-left:80px}.image-logo[data-v-c8fe1ea6]{width:70px;margin-right:20px}.title[data-v-c8fe1ea6]{font-family:\"Orbitron\";font-weight:900;color:#58aac3;font-size:32px}.image[data-v-c8fe1ea6]{margin-top:10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
